// What the matter's own papers say is wrong: a retainer nobody signed, a
// form drafted with no filed copy. The server computes it on every read,
// so the card goes away by itself when the paper arrives. A read that
// failed says nothing - a matter card is not the place to report on it.

import { useCaseSignals } from "../../hooks/useCaseSignals";
import type { CaseSignal } from "../../api/caseSignals";

const WORD: Record<CaseSignal["kind"], string> = {
  retainer_unsigned: "Retainer not signed",
  not_filed: "Not filed",
  translation_missing: "Translation missing",
};

export function SignalNotice({ caseId }: { caseId: string }) {
  const signals = useCaseSignals(caseId);
  const rows = signals.data ?? [];
  if (rows.length === 0) return null;
  const critical = rows.some((s) => s.severity === "critical");
  // Functional status colors only: red for critical, amber for a gap.
  const tone = critical ? "var(--red-700)" : "var(--warn-600)";
  return (
    <div
      className="cc-card"
      data-testid="signal-notice"
      style={{ padding: "12px 18px", marginBottom: 12, border: `1px solid ${tone}` }}
    >
      {rows.map((s, i) => (
        <div key={`${s.kind}:${i}`} style={{ lineHeight: 1.5 }}>
          <b style={{ color: s.severity === "critical" ? "var(--red-700)" : "var(--warn-600)" }}>
            {WORD[s.kind]}
          </b>
          : {s.message}
        </div>
      ))}
    </div>
  );
}
